import { flags } from '@lib/feature-flags/constants'

/** Golf-facilities SDK SSR for `/play` — only the dedicated datasource flag. */
export function isGolfFacilitiesDataSourceEnabled(featureFlags) {
  return Boolean(featureFlags?.[flags.FLAG_FACILITY_GOLF_FACILITIES_DATASOURCE])
}
